<script lang="ts" setup></script>

<template>
  <svg width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path id="Polygon 6" d="M3.5 0L6.53109 4.5H0.468911L3.5 0Z" fill="#F40000" />
  </svg>
</template>
